import React, { useState } from 'react';

const UnitComponent = () => {
  const [unitList, setUnitList] = useState([
    { id: 1, name: 'Pieces', symbol: 'pcs', type: 'Simple', setValue: 1, status: 'Deactive' }
  ]);
  const [unitName, setUnitName] = useState('');
  const [unitSymbol, setUnitSymbol] = useState('');
  const [unitType, setUnitType] = useState('Simple');
  const [setValue, setSetValue] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  const [currentUnit, setCurrentUnit] = useState(null);

  // Handle input changes
  const handleUnitNameChange = (e) => setUnitName(e.target.value);
  const handleUnitSymbolChange = (e) => setUnitSymbol(e.target.value);
  const handleUnitTypeChange = (e) => setUnitType(e.target.value);
  const handleSetValueChange = (e) => setSetValue(Number(e.target.value));

  // Create Unit
  const handleCreateUnit = () => {
    if (unitName.trim() && unitSymbol.trim()) {
      const newUnit = {
        id: unitList.length + 1,
        name: unitName,
        symbol: unitSymbol,
        type: unitType,
        setValue,
        status: 'Deactive'
      };
      setUnitList([...unitList, newUnit]);
      resetForm();
    }
  };

  // Edit Unit
  const handleEditUnit = (unit) => {
    setUnitName(unit.name);
    setUnitSymbol(unit.symbol);
    setUnitType(unit.type);
    setSetValue(unit.setValue);
    setCurrentUnit(unit);
    setIsEditing(true);
  };

  // Update Unit
  const handleUpdateUnit = () => {
    const updatedUnit = {
      ...currentUnit,
      name: unitName,
      symbol: unitSymbol,
      type: unitType,
      setValue
    };
    setUnitList(
      unitList.map((unit) => (unit.id === currentUnit.id ? updatedUnit : unit))
    );
    resetForm();
  };

  // Cancel editing or creation
  const handleCancel = () => {
    resetForm();
  };

  // Reset form to default state
  const resetForm = () => {
    setUnitName('');
    setUnitSymbol('');
    setUnitType('Simple');
    setSetValue(1);
    setIsEditing(false);
    setCurrentUnit(null);
  };

  // Delete Unit
  const handleDeleteUnit = (unitId) => {
    setUnitList(unitList.filter((unit) => unit.id !== unitId));
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>{isEditing ? 'Edit Unit' : 'Create Unit'}</h1>

      {/* Form to create or update Unit */}
      <div style={styles.formContainer}>
        <div style={styles.inputGroup}>
          <label style={styles.label}>Unit Type</label>
          <select value={unitType} onChange={handleUnitTypeChange} style={styles.input}>
            <option value="Simple">Simple</option>
            <option value="Complex">Complex</option>
          </select>
        </div>

        <div style={styles.inputGroup}>
          <label style={styles.label}>Unit Name</label>
          <input
            type="text"
            value={unitName}
            onChange={handleUnitNameChange}
            placeholder="Enter Unit Name"
            style={styles.input}
          />
        </div>

        <div style={styles.inputGroup}>
          <label style={styles.label}>Unit Symbol</label>
          <input
            type="text"
            value={unitSymbol}
            onChange={handleUnitSymbolChange}
            placeholder="Enter Unit Symbol"
            style={styles.input}
          />
        </div>

        <div style={styles.inputGroup}>
          <label style={styles.label}>Set Value</label>
          <input
            type="number"
            value={setValue}
            onChange={handleSetValueChange}
            placeholder="Enter Set Value"
            style={styles.input}
          />
        </div>

        <div style={styles.buttonGroup}>
          <button
            onClick={isEditing ? handleUpdateUnit : handleCreateUnit}
            style={styles.primaryButton}
          >
            {isEditing ? 'Update Unit' : 'Create Unit'}
          </button>
          <button onClick={handleCancel} style={styles.secondaryButton}>
            Cancel
          </button>
        </div>
      </div>

      {/* Unit List */}
      <h2 style={styles.subHeading}>Unit List</h2>
      <table style={styles.table}>
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Unit Name</th>
            <th>Symbol</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {unitList.map((unit, index) => (
            <tr key={unit.id} style={styles.tableRow}>
              <td>{unit.id}</td>
              <td>{unit.name}</td>
              <td>{unit.symbol}</td>
              <td style={styles.actions}>
                <button
                  onClick={() => handleEditUnit(unit)}
                  style={styles.editButton}
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDeleteUnit(unit.id)}
                  style={styles.deleteButton}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles for the components
const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    margin: '0 auto',
    padding: '20px',
    maxWidth: '1000px',
  },
  heading: {
    textAlign: 'center',
    fontSize: '28px',
    marginBottom: '30px',
    color: '#333',
  },
  subHeading: {
    textAlign: 'center',
    fontSize: '22px',
    marginTop: '40px',
    marginBottom: '20px',
    color: '#333',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '30px',
    borderRadius: '10px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    padding: '20px',
    backgroundColor: '#f9f9f9',
  },
  inputGroup: {
    marginBottom: '20px',
  },
  label: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '5px',
    display: 'block',
    color: '#333',
  },
  input: {
    width: '100%',
    padding: '10px',
    fontSize: '14px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  primaryButton: {
    padding: '12px 25px',
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'background-color 0.3s',
  },
  secondaryButton: {
    padding: '12px 25px',
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'background-color 0.3s',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
    fontSize: '14px',
  },
  tableRow: {
    borderBottom: '1px solid #ddd',
    backgroundColor: '#f9f9f9',
  },
  actions: {
    textAlign: 'center',
  },
  editButton: {
    padding: '5px 10px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px',
    marginRight: '10px',
    transition: 'background-color 0.3s',
  },
  deleteButton: {
    padding: '5px 10px',
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'background-color 0.3s',
  },
};

export default UnitComponent;
